export default "__VITE_ASSET__573aac2b__"